/* Cudeman · Hero inteligente de la home.
   - Cuenta atras de entrega (misma regla que las fichas: corte 12:00 hora de Madrid, sin fines de semana)
   - Personalizacion: pieza que recomendo el selector + piezas vistas hace poco (cookie que ya usa el tema)
   - Carrusel del escaparate y medicion (kf_hero_view / kf_hero_click) */
(function () {
  'use strict';
  document.querySelectorAll('[data-kfx]').forEach(init);

  function init(root) {
    var CFG = {};
    try { CFG = JSON.parse(root.getAttribute('data-kfx-config') || '{}'); } catch (e) {}
    var track = root.querySelector('[data-kfx-track]'), dots = root.querySelector('[data-kfx-dots]');
    var isEn = CFG.lang === 'en', variant = CFG.variant || 'general', base = (CFG.root || '/').replace(/\/?$/, '/');

    function send(name, data) {
      data = Object.assign({ variante: variant }, data || {});
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    }

    // ---------------- entrega
    var eta = root.querySelector('[data-kfx-eta]');
    function renderEta() {
      if (!eta) return;
      var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' })), dow = now.getDay();
      var today = dow >= 1 && dow <= 5 && now.getHours() < 12, ship = new Date(now);
      if (!today) { do { ship.setDate(ship.getDate() + 1); } while (ship.getDay() === 0 || ship.getDay() === 6); }
      var del = new Date(ship);
      do { del.setDate(del.getDate() + 1); } while (del.getDay() === 0 || del.getDay() === 6);
      var tom = new Date(now); tom.setDate(tom.getDate() + 1);
      var isTom = del.toDateString() === tom.toDateString();
      var day = del.toLocaleDateString(isEn ? 'en-GB' : 'es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
      var t;
      if (today) {
        var m = 12 * 60 - (now.getHours() * 60 + now.getMinutes());
        var left = (Math.floor(m / 60) > 0 ? Math.floor(m / 60) + 'h ' : '') + (m % 60) + 'min';
        t = isEn ? 'Order within <strong>' + left + '</strong> and get it <strong>' + (isTom ? 'tomorrow, ' : '') + day + '</strong>'
                 : 'Pídelo en <strong>' + left + '</strong> y recíbelo <strong>' + (isTom ? 'mañana, ' : 'el ') + day + '</strong>';
      } else {
        t = isEn ? 'Order now and get it <strong>' + day + '</strong>' : 'Pídelo ahora y recíbelo <strong>el ' + day + '</strong>';
      }
      eta.querySelector('span').innerHTML = t;
      eta.hidden = false;
    }
    renderEta();
    setInterval(renderEta, 60000);

    // ---------------- carrusel
    var timer, settle;
    function btns() { return dots ? dots.querySelectorAll('button') : []; }
    function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function mark() { var n = cur(); [].forEach.call(btns(), function (b, k) { b.classList.toggle('is-on', k === n); b.setAttribute('aria-current', k === n); }); }
    function go(n) { var c = btns().length || 1; n = (n + c) % c; track.scrollTo({ left: track.clientWidth * n, behavior: 'smooth' }); setTimeout(mark, 650); }
    function play() {
      clearInterval(timer);
      if (btns().length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { if (!document.hidden) go(cur() + 1); }, 5000);
    }
    function rebuildDots() {
      if (!dots) return;
      var n = track.querySelectorAll('.kfx__slide').length, h = '';
      for (var i = 0; i < n; i++) h += '<button type="button" aria-label="' + (i + 1) + '"' + (i === 0 ? ' class="is-on"' : '') + '></button>';
      dots.innerHTML = h;
      dots.hidden = n < 2;
      [].forEach.call(btns(), function (b, k) { b.addEventListener('click', function () { go(k); play(); }); });
    }
    if (track) {
      rebuildDots();
      track.addEventListener('scroll', function () { clearTimeout(settle); settle = setTimeout(mark, 90); }, { passive: true });
      track.addEventListener('scrollend', mark);
      track.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
      track.addEventListener('touchend', play, { passive: true });
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', play);
      window.addEventListener('resize', function () { track.scrollLeft = track.clientWidth * cur(); });
      play();
    }

    // ---------------- personalizacion
    function money(c) {
      var v = c / 100, f = CFG.money || '€{{amount_with_comma_separator}}';
      function d(n, th, ds) { var s = n.toFixed(2).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return s.join(ds); }
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) { return k.indexOf('comma') >= 0 ? d(v, '.', ',') : d(v, ',', '.'); });
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function prefsAllowed() {   // respeta el aviso de cookies si la tienda lo usa
      try { var cp = window.Shopify && Shopify.customerPrivacy; if (cp && cp.preferencesProcessingAllowed) return cp.preferencesProcessingAllowed(); } catch (e) {}
      return true;
    }
    var arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    function slideHTML(p, badge, href) {
      var img = p.featured_image || '';
      if (img.indexOf('//') === 0) img = 'https:' + img;
      if (img) img += (img.indexOf('?') > 0 ? '&' : '?') + 'width=900';
      var from = p.price_varies ? (isEn ? 'From ' : 'Desde ') : '';
      return '<a class="kfx__slide" href="' + esc(href) + '" aria-label="' + esc(p.title) + '" data-kfx-h="' + esc(p.handle) + '">' +
        '<span class="kfx__img"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="900" height="900"></span>' +
        '<span class="kfx__card"><span class="kfx__card-tx"><span class="kfx__badge">' + esc(badge) + '</span><span class="kfx__name">' + esc(p.title.replace(/^Cudeman\s+/i, '')) + '</span></span>' +
        '<span class="kfx__price">' + from + money(p.price) + '</span><span class="kfx__go">' + arrow + '</span></span></a>';
    }
    function fetchP(h) {
      return fetch(base + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    function personalize() {
      if (!track || !CFG.personal || !prefsAllowed()) return Promise.resolve(null);
      var wanted = [], last = null, seen = [];
      try { last = JSON.parse(localStorage.getItem('kf_last') || 'null'); } catch (e) {}
      if (last && last.h && last.u && Date.now() - (last.t || 0) < 30 * 864e5) wanted.push({ h: last.h, badge: CFG.badgeSelector, href: last.u, kind: 'selector' });
      try {
        var m = document.cookie.match(/(?:^|; )shopify_recently_viewed=([^;]*)/);
        if (m) seen = decodeURIComponent(m[1]).split(' ').filter(Boolean);
      } catch (e) {}
      seen.forEach(function (h) { if (wanted.length < 3 && !wanted.some(function (w) { return w.h === h; })) wanted.push({ h: h, badge: CFG.badgeSeen, kind: 'vistos' }); });
      if (!wanted.length) return Promise.resolve(null);
      return Promise.all(wanted.map(function (w) { return fetchP(w.h); })).then(function (ps) {
        var html = '', kinds = [], used = {};
        ps.forEach(function (p, i) {
          if (!p || !p.available || used[p.handle]) return;
          var w = wanted[i];
          used[p.handle] = 1; kinds.push(w.kind);
          html += slideHTML(p, w.badge, w.href || (base + 'products/' + p.handle));
        });
        if (!html) return null;
        var keep = [].filter.call(track.querySelectorAll('.kfx__slide'), function (a) { return !used[a.getAttribute('data-kfx-h')]; });
        track.innerHTML = html + keep.slice(0, Math.max(0, 4 - kinds.length)).map(function (a) { return a.outerHTML; }).join('');
        track.scrollLeft = 0;
        rebuildDots();
        play();
        return kinds.indexOf('selector') >= 0 ? 'selector' : 'vistos';
      });
    }
    personalize().catch(function () { return null; }).then(function (k) {
      if (k) variant = k + (CFG.variant && CFG.variant !== 'general' ? '+' + CFG.variant : '');
      root.setAttribute('data-kfx-variant', variant);
      send('kf_hero_view', { piezas: [].map.call(root.querySelectorAll('.kfx__slide'), function (a) { return a.getAttribute('data-kfx-h'); }).join(',') });
    });

    // ---------------- medicion de clics
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var el = a.classList.contains('kfx__slide') ? 'pieza' : a.classList.contains('kfx__chip') ? 'uso' : a.classList.contains('kfx__help') ? 'selector'
        : a.classList.contains('kfx__btn--lime') ? 'boton_principal' : 'boton_secundario';
      send('kf_hero_click', { elemento: el, destino: a.getAttribute('href') || '', pieza: a.getAttribute('data-kfx-h') || '' });
    });
  }
})();
